export enum SHARED_KEYS_APPS {
    iv = '6546LJS8CAkGDP6y',
    secretKey = 'SqX4exD8MjQsM0j89FMTWpiJCAkGDP6x'
}